export { default as pilsner } from '../../../../projects/pilsner/admin/src'
